import { combineReducers } from "redux";
import screenDim from "./screenDim";
import userSession from "./userSession";

export default combineReducers({
    userSession: userSession,
    screenDim: screenDim,
});
